import React from 'react';
import { Col, Card, Row, Table } from 'antd';
import PrintForm2 from '/react4xp/mixins/ui/print-form-2';
import PrintIcon from '../../../icons/print.svg';
import { url } from './actions';
import { localize } from '/react4xp/mixins/helpers';
import './find-nds-payer-service.scss';

const Results = (props: any) => {
    const { data, columns, values, translations } = props;

    return (
        <div className="response">
            <Col
                md={24}
                xs={24}
                lg={24}
            >
                <div className="response__title">
                    {localize('print-form.search-results', translations)}
                </div>
            </Col>
            {Object.keys(data).length ? (
                <div className="taxpayer">
                    <Col
                        md={12}
                        xs={24}
                        lg={12}
                    >
                        <Card className="card mb-4">
                            <div className="card__title">{data?.name}</div>
                            <Row>
                                <Col>
                                    <div>{localize('iin-bin', translations)}</div>
                                    <div>
                                        {data?.iinBin || localize('no-data', translations)}
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    <Table
                        {...props}
                        className={'table-default'}
                        rowKey={(record) => record && record.id}
                        dataSource={[data]}
                        bordered
                        columns={columns}
                    />
                    <PrintForm2
                        apiUrl={url}
                        icon={<PrintIcon />}
                        params={values}
                        isPost
                        translations={translations}
                    />
                </div>
            ) : (
                <div className="response__total">
                    {localize('notification.no-data', translations)}
                </div>
            )}
        </div>
    );
};

export default Results;
